import { render, staticRenderFns } from "./brand.vue?vue&type=template&id=1102a5c0&scoped=true"
import script from "./brand.vue?vue&type=script&lang=js"
export * from "./brand.vue?vue&type=script&lang=js"
import style0 from "./brand.vue?vue&type=style&index=0&id=1102a5c0&prod&lang=scss&scoped=true"
import style1 from "./brand.vue?vue&type=style&index=1&id=1102a5c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1102a5c0",
  null
  
)

export default component.exports